import { render, staticRenderFns } from "./TaskAssignment.vue?vue&type=template&id=4cfdecda&scoped=true"
import script from "./TaskAssignment.vue?vue&type=script&lang=js"
export * from "./TaskAssignment.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignment.vue?vue&type=style&index=0&id=4cfdecda&prod&scoped=true&lang=css"
import style1 from "./TaskAssignment.vue?vue&type=style&index=1&id=4cfdecda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfdecda",
  null
  
)

export default component.exports